module.exports = __webpack_public_path__ + "img/arrowsGreen.0d7212db.png";